import { useEffect } from 'react'

import { ComparatorOperation, ComparatorType } from './useComparatorOperations'

export const useFallbackComparator = (
  operations: ComparatorOperation[],
  selectedOperation: ComparatorType,
  setSelectedOperation: (operation: ComparatorType) => void,
) => {
  useEffect(() => {
    if (
      !operations.find((operation) => operation.value === selectedOperation)
    ) {
      setSelectedOperation(operations[0]?.value ?? 'is')
    }
  }, [operations])
}
